import { ROLE_LEVELS } from '@/types/user';

/**
 * The header location switcher's 'all' option (T22, Shopify style). The owner
 * gets 'All Locations' — every store. A manager with 2+ stores gets 'All my
 * locations' — the API sums only their assigned stores. A cashier, or anyone
 * with a single store, gets no 'all' option and works in one store.
 */
export function headerAllLocations(
  roleLevel: number,
  storeCount: number,
): { show: boolean; label: string } {
  const isOwner = roleLevel >= ROLE_LEVELS.OWNER;
  return {
    show: storeCount >= 2 && roleLevel >= ROLE_LEVELS.MANAGER,
    label: isOwner ? 'All Locations' : 'All my locations',
  };
}

/**
 * The store the header should hold: `selected` while it is one of the user's
 * stores; else all of them (undefined) when the user has the 'all' option or a
 * single store (the API pins it), else their first store — so the header never
 * reads 'all' for someone who can't choose it, nor keeps a store from another
 * sign-in.
 */
export function headerLocationSelection(
  selected: string | undefined,
  storeIds: string[],
  allowAll: boolean,
): string | undefined {
  if (selected && storeIds.includes(selected)) return selected;
  return allowAll || storeIds.length < 2 ? undefined : storeIds[0];
}
